// extracted by mini-css-extract-plugin
export default {"input":"X8-z","button":"Y8-z","selected":"Z8-z","unavailable":"_8-z","oos":"a9-z","image":"b9-z","paperCutDisabledOverlay":"c9-z"};